import { render, staticRenderFns } from "./SoftwareAdd.vue?vue&type=template&id=6a271459"
import script from "./SoftwareAdd.vue?vue&type=script&lang=js"
export * from "./SoftwareAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports